import { ArrowLeftOutlined, CheckCircleFilled } from "@ant-design/icons";
import { Breadcrumb, Button, Col, Form, Input, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import changePassowordIcon from "../../assets/images/icon/changePass.svg";
import Heading from "../../components/common/heading";
import useCancelModal from "../../lib/hooks/useCancelModal";
import { changePassword } from "../../services/profileService";
import WithSidebar from "../../templates/withSidebar";
import ModalResponse from "./modalResponse";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { setOpenCancelModal } = useCancelModal();
  const [submittable, setSubmittable] = useState(false);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [validPassword, setValidPassword] = useState({
    length: 0,
    uppercase: false,
    lowercase: false,
    numberic: false,
    special_chars: false,
  });
  const [modalResp, setModalResp] = useState({
    show: false,
    success: false,
  });
  const [errMsg, setErrMsg] = useState("");

  function containsUppercase(str) {
    return /[A-Z]/.test(str);
  }

  function containsLowercase(str) {
    return /[a-z]/.test(str);
  }

  function containsNumberic(num) {
    return /[0-9]/.test(num);
  }

  function containsSpecialChars(str) {
    return /[-+_!@#$%^&*.,?]/.test(str);
  }

  const onFinish = async (values) => {
    const request = {
      current_p: values.current_p,
      new_p: values.new_p,
      confirm_p: values.confirm_p,
    };

    const res = await changePassword(request);

    if (res.data.code === "0000") {
      setModalResp({
        show: true,
        success: true,
      });
    } else {
      setModalResp({
        show: true,
        success: false,
      });
      if (res?.data?.code === "ERR-0015") {
        setErrMsg("โปรดตรวจสอบรหัสผ่านใหม่อีกครั้ง");
      } else if (res.data.code === "ERR-9999") {
        setErrMsg("โปรดตรวจสอบให้แน่ใจว่ารหัสผ่านเดิมของคุณถูกต้องแล้ว");
      } else {
        setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
      }
    }
  };

  useEffect(() => {
    if (values?.new_p && values?.current_p && values?.confirm_p) {
      setErrMsg("");
      setSubmittable(true);
    }
    if (values?.new_p) {
      setValidPassword({
        length: values.new_p ? values.new_p?.length : 0,
        uppercase: values.new_p ? containsUppercase(values.new_p) : false,
        lowercase: values.new_p ? containsLowercase(values.new_p) : false,
        numberic: values.new_p ? containsNumberic(values.new_p) : false,
        special_chars: values.new_p
          ? containsSpecialChars(values.new_p)
          : false,
      });
    }
  }, [values, form, submittable]);

  return (
    <WithSidebar>
      <Row gutter={[16]}>
        <Col span={24}>
          <div className="flex items-center">
            <Space size={12}>
              <Button
                type="link"
                onClick={() => {
                  setOpenCancelModal(true);
                }}
                style={{ padding: 0 }}
              >
                <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
              </Button>
              <Heading
                text={"เปลี่ยนรหัสผ่าน"}
                size={4}
                style={{ margin: 0 }}
              />
            </Space>
          </div>
          <Breadcrumb
            style={{ paddingTop: 10 }}
            items={[
              {
                title: "ข้อมูลส่วนตัว",
              },
              {
                title: <span className="pr_green">เปลี่ยนรหัสผ่าน</span>,
              },
            ]}
          />
        </Col>
      </Row>

      <div style={{ margin: "40px 200px" }}>
        <Row gutter={[24]} style={{ marginBottom: 25 }}>
          <Col span={24} align="center">
            <img
              src={changePassowordIcon}
              width={100}
              height={100}
              alt="edit profile"
            />
          </Col>
          <Col span={24} align="center">
            <Heading
              text={"สร้างรหัสผ่านใหม่"}
              size={4}
              style={{ margin: 0 }}
            />
            <p style={{ color: "#8187A6" }}>
              รหัสผ่านใหม่ของคุณต้องแตกต่างจากรหัสผ่านที่เคยใช้มาก่อนหน้านี้
            </p>
          </Col>

          <Col span={24}>
            {errMsg && (
              <p
                style={{
                  color: "#F04438",
                  textAlign: "center",
                }}
              >
                {errMsg}
              </p>
            )}
          </Col>
        </Row>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          style={{ width: 450, margin: "auto" }}
        >
          <Row gutter={[24, 16]}>
            <Col span={24}>
              <Form.Item
                label="รหัสผ่านปัจจุบัน"
                name={"current_p"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input.Password placeholder="รหัสผ่านปัจจุบัน" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="รหัสผ่านใหม่"
                name={"new_p"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                  {
                    pattern:
                      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=[a-zA-Z\d].*[-+_!@#$%^&*.,?].*[a-zA-Z\d]$)[a-zA-Z\d\-+_!@#$%^&*.,?]{8,}$/,
                    message: `รูปแบบรหัสผ่านไม่ถูกต้อง`,
                  },
                ]}
              >
                <Input.Password placeholder="รหัสผ่านใหม่" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="ยืนยันรหัสผ่านใหม่"
                name={"confirm_p"}
                dependencies={["new_p"]}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("new_p") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("โปรดตรวจสอบให้แน่ใจว่ารหัสผ่านของคุณตรงกัน")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="ยืนยันรหัสผ่านใหม่" />
              </Form.Item>
            </Col>

            <Col span={24} align="left" style={{ marginTop: 20 }}>
              <ul style={{ listStyleType: "none", padding: 5, margin: 0 }}>
                <li
                  style={{
                    marginBottom: 5,
                    color: `${
                      validPassword?.length > 7 ? "#12B76A" : "#667085"
                    }`,
                  }}
                >
                  <CheckCircleFilled /> ตั้งรหัสผ่าน 8-12 ตัวอักษรขึ้นไป
                </li>
                <li
                  style={{
                    marginBottom: 5,
                    color: `${
                      validPassword?.uppercase ? "#12B76A" : "#667085"
                    }`,
                  }}
                >
                  <CheckCircleFilled /> มีอักษรตัวใหญ่อย่างน้อย 1 ตัว [A-Z]
                </li>
                <li
                  style={{
                    marginBottom: 5,
                    color: `${
                      validPassword?.lowercase ? "#12B76A" : "#667085"
                    }`,
                  }}
                >
                  <CheckCircleFilled /> มีอักษรตัวเล็กอย่างน้อย 1 ตัว [a-z]
                </li>
                <li
                  style={{
                    marginBottom: 5,
                    color: `${validPassword?.numberic ? "#12B76A" : "#667085"}`,
                  }}
                >
                  <CheckCircleFilled /> มีตัวเลขอย่างน้อย 1 ตัว [0-9]
                </li>
                <li
                  style={{
                    marginBottom: 5,
                    color: `${
                      validPassword?.special_chars ? "#12B76A" : "#667085"
                    }`,
                  }}
                >
                  <CheckCircleFilled />{" "}
                  {"มีอักขระพิเศษอย่างน้อย 1 ตัว [-+_!@#$%^&*.,?]"}
                </li>
              </ul>
            </Col>

            <Col span={24} align="center" style={{ marginTop: 20 }}>
              <Button
                style={{ width: "100%" }}
                type="primary"
                htmlType="submit"
                disabled={!submittable}
              >
                ยืนยันสร้างรหัสผ่านใหม่
              </Button>
            </Col>
          </Row>
        </Form>
      </div>

      <ModalResponse
        type={modalResp.success}
        open={modalResp.show}
        setOpen={setModalResp}
        title={
          modalResp.success ? "เปลี่ยนรหัสผ่านใหม่สำเร็จ" : "มีบางอย่างผิดพลาด"
        }
        subTitle={
          modalResp.success
            ? "บัญชีของคุณได้ทำการเปลี่ยนรหัสผ่านเรียบร้อยแล้ว ท่านสามารถเข้าสู่ระบบเพื่อใช้งานได้แล้วค่ะ"
            : "มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"
        }
      />
    </WithSidebar>
  );
};

export default ChangePassword;
